/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store/index'

// router modules
import registration from './registration'
import vendor from './vendor'
import admin from './admin'
import rup from './rup'
import spk from "./spk"
import monitor from "./monitor"
import person from "./person"
import user from './user'
import rpt from './rpt'
import kebijakanvendor from './kebijakanvendor'
//** eproc */
import ppk from "./ppk"
import panitia from "./panitia"

// Views or Components declaration
import Home from '../views/Home.vue'
import Page404 from '../views/misc/Page404.vue'
import Page401 from './../views/misc/Page401.vue'
import Forget from './../views/misc/Forget.vue'
import ResetPassword from './../views/misc/ResetPassword.vue'
import FrontHome from "./../views/FrontHome.vue"
import FrontRUP from "./../views/FrontRUP.vue"
import FrontProsedur from "./../views/FrontProsedur.vue"
import FrontKontak from "./../views/FrontKontak.vue"
import FrontMasaSanggah from "./../views/FrontMasaSanggah.vue"
import FrontHasilTender from "./../views/FrontHasilTender.vue"
import FrontInformasi from "./../views/FrontInformasi.vue"
import FrontBerita from "./../views/FrontBerita.vue"
import ProsesLelangUmum from './../views/ProsesLelangUmum.vue'
import FrontKebijakanVendor from './../views/FrontKebijakanVendor.vue'


//** eproc */
import TestComponents from "./../views/TestComponents.vue";

Vue.use(VueRouter)

const varRoutes = [
  {
    path: "/",
    component: FrontHome,
    name: "Home"
  },
  {
    path: "/rup-kegiatan",
    component: FrontRUP,
    name: "RUP Kegiatan"
  },
  {
    path: "/prosedur",
    component: FrontProsedur,
    name: "Prosedur"
  },
  {
    path: "/kontak",
    component: FrontKontak,
    name: "Kontak"
  },
  {
    path: "/masa-sanggah",
    component: FrontMasaSanggah,
    name: "Masa Sanggah"
  },
  {
    path: "/hasil-tender",
    component: FrontHasilTender,
    name: "Hasil Tender"
  },
  {
    path: '/lelang',
    component: ProsesLelangUmum,
    name: 'Lelang'
  },  
  {
    path: '/informasi',
    component: FrontInformasi,
    name: 'Informasi'
  },  
  {
    path: '/berita',
    component: FrontBerita,
    name: 'Berita'
  },  
  {
    path: "/kebijakan-vendor",
    component: FrontKebijakanVendor,
    name: "Kebijakan Vendor"
  },
  {
    path: '/login',
    component: Home,
    name: 'Login',
  },  
  {
    path: '/401',
    component: Page401,
    name: '401'
  },  
  {
    path: '/forget',
    component: Forget,
    name: 'forget'
  },  
  {
    path: '/userman/forget/:kodeUrl',
    component: ResetPassword,
    name: 'reset'
  },  
  //** eproc */
  {
    path: "/test/components",
    component: TestComponents,
    name: "TestComponents"
  },
  {
    path: '*',
    component: Page404,  
    name: '404'
  }
]

// const routes = [].concat(registration, vendor, admin, rup, user, varRoutes)
const routes = [...registration, ...vendor, ...admin, ...rup, ...user, ...varRoutes, ...ppk, ...panitia, ...spk, ...monitor, ...person, ...rpt, ...kebijakanvendor]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) { // harus authentikasi
    if (store.getters.isAuthenticated) { //sudah login
      // check berdasarkan user roles
      next()
    }
    else { // belum login
      next('/')
    } 
  } else { // tidak perlu authentikasi
    next() 
  }
})

export default router
